import { get } from "lodash";

const AGELESSTHANONE = "6 weeks to 11 months";

export const getBreedName = (breedId, petType, dogBreeds, catBreeds) => {
    if (breedId && petType && dogBreeds && catBreeds) {
        return petType === "DOG" ? dogBreeds[breedId]?.label : petType === "CAT" ? catBreeds[breedId]?.label : null;
    }
    return null;
};

export const getBreedNames = (pets) => {
    const breedNames = pets.map((pet) => {
        const names = pet.breedName;
        return names;
    });

    return breedNames;
};

export const getPetTypes = (pets) => {
    const types = pets.map((pet) => pet.petType);
    return types;
};

export const getAppendedAge = (age) => {
    if (age === 0) {
        age = AGELESSTHANONE;
    } else if (age === 1) {
        age = `${age} year`;
    } else {
        age = `${age} years`;
    }
    return age;
};

export const getPetAges = (pets) => {
    const ages = pets.map((pet) => {
        let age = get(pet, "dob.petAge");
        age = getAppendedAge(age);
        return age;
    });
    return ages;
};

export const getPayouts = (pets) => {
    const quotes = pets.map((pet) => pet.quotes[0]);
    const payouts = quotes.map((quote) => quote.annualPolicyMaximumLimit);
    return payouts;
};

export const getDeductibles = (pets) => {
    const quotes = pets.map((pet) => pet.quotes[0]);
    const deductibles = quotes.map((quote) => quote.annualDeductibleDollarAmount);
    return deductibles;
};

export const getReimbursements = (pets) => {
    const quotes = pets.map((pet) => pet.quotes[0]);
    const reimbursements = quotes.map((quote) => quote.coPayPercentage);
    return reimbursements;
};

export const getEffectiveDates = (pets) => {
    const quotes = pets.map((pet) => pet.quotes[0]);
    const effectiveDates = quotes.map((quote) => quote.effectiveDate);
    return effectiveDates;
};
